exports.allowedRoutes = {
  home: "/",
  login: "/cuisine/compass/login",
  register: "/cuisine/compass/register",
  restaurants: "/cuisine/compass/restaurants",
  menu: "/cuisine/compass/restaurants/menu",
  cartItems:
    "/cuisine/compass/restaurants/menu/showcart",
  contact: "/cuisine/compass/contact",
  myaccount:
    "/cuisine/compass/restaurants/profile/account",
  business: "/cuisine/compass/mybusiness/signup",
  businessmain: "/cuisine/compass/business",
  faq: "/cuisine/compass/faq",
  delivery: "/cuisine/compass/delivery",
  deliveryForm: "/cuisine/compass/delivery/form",
  threedim: "/cuisine/compass/view/threedim",
  settings: "/cuisine/compass/settings",
  forgotPass: "/cuisine/compass/forgot/password",
  preferences: "/cuisine/compass/preferences",
};
